import React from 'react';
import { useHistory } from 'react-router';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import {
  ChecklistEntityIcon,
  DashboardEntityIcon,
  CompendiumEntityIcon,
  KnowledgeBaseEntityIcon,
  BookmarkEntityIcon,
  ContactsEntityIcon,
} from '../../../images';
import { ROUTES, Lang, DATA_KEYS } from 'shared/constants';
import styles from './Sidebar.module.scss';
import classnames from 'classnames';
import { scrollTo } from '../../../utils';
import { isContactsFeatureEnabled } from 'shared/store/selectors/features.selector';
const { HOME_PAGE } = DATA_KEYS;

const MenuItem = React.memo(
  ({ path, title, icon: Icon, sub = [], exact = true, hide = false, ...props }) => {
    let isActive = useRouteMatch({
      path,
      strict: true,
      exact: true,
      sensitive: true,
    });

    const history = useHistory();
    const to = _.isArray(path) ? path[0] : path;

    const onSubmenuClick = id => {
      if (isActive) {
        scrollTo(id);
        return;
      }

      history.push(to);
      setTimeout(() => {
        scrollTo(id);
      }, 100);
    };

    if (hide) return null;

    return (
      <div className={styles.menuRoot}>
        <NavLink
          exact={exact}
          className={styles.menuItem}
          activeClassName={styles.active}
          key={path}
          to={to}
          {...props}
        >
          <Icon className={styles.icon} />
          {title}
        </NavLink>
        <div className={classnames(styles.subMenu, styles.subMenuOpen)}>
          {sub &&
            sub.map(({ title, id }) => (
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <a
                key={`submenu-${id}`}
                onClick={() => onSubmenuClick(id)}
                className={styles.subMenuItem}
              >
                {title}
              </a>
            ))}
        </div>
      </div>
    );
  },
);

const SidebarComponent = React.memo(({ lang, rootItems, knowledgeLastUpdate }) => {
  const isContactsEnabled = useSelector(isContactsFeatureEnabled);

  const routes = [
    {
      path: ROUTES.HOME,
      icon: props => <img src={DashboardEntityIcon} alt={lang.ROOT} {...props} />,
      title: 'Dashboard',
    },
    {
      path: ROUTES.FAVORITES,
      icon: props => <img src={BookmarkEntityIcon} alt={lang.FAVORITES} {...props} />,
      title: lang.FAVORITES,
    },
    {
      path: ROUTES.CONTACTS,
      icon: props => <img src={ContactsEntityIcon} alt={lang.CONTACTS} {...props} />,
      title: lang.CONTACTS,
      hide: !isContactsEnabled,
    },
    {
      path: ROUTES.ADMISSION,
      icon: props => <img src={ChecklistEntityIcon} alt={lang.ADMISSION} {...props} />,
      exact: false,
      title: lang.ADMISSION,
    },
    {
      path: ROUTES.LABS,
      icon: props => <img src={CompendiumEntityIcon} alt={lang.LAB} {...props} />,
      exact: false,
      title: lang.LAB,
    },
    {
      path: [ROUTES.KNOWLEDGE, ROUTES.CONTENT_ITEM],
      exact: false,
      icon: props => <img src={KnowledgeBaseEntityIcon} alt={lang.ROOT} {...props} />,
      title: lang.ROOT,
      'data-key': HOME_PAGE.KNOWLEDGE,
      sub:
        rootItems &&
        rootItems.map(({ id, title }) => ({
          id,
          title,
        })),
    },
  ];

  return (
    <div className={styles.sidebar} key={knowledgeLastUpdate} data-key={HOME_PAGE.SIDEBAR}>
      {routes.map(item => (
        <MenuItem key={item.path} {...item} />
      ))}
    </div>
  );
});

SidebarComponent.defaultProps = {
  lang: Lang.SIDEBAR,
  organization: {},
  rootItems: [],
};

export { SidebarComponent };
